import LoLInstruction from './LoLInstruction';

export default LoLInstruction;
